export class CrudApiService {
  constructor(http, endpoint, adapter) {
    this.endpoint = endpoint;
    this.http = http;
    if (typeof adapter !== 'undefined') {
      if (typeof adapter.serialize !== 'undefined') {
        this.serialize = adapter.serialize;
      }
      if (typeof adapter.deserialize !== 'undefined') {
        this.deserialize = adapter.deserialize;
      }
    }
  }
  /**
   * @param {number} limit
   * @param {number} offset
   * @param {string} search
   * @param {Array} sorts { id: 'asc', 'date': 'desc', ... }
   */
  async getAll(limit, offset, search, sorts, anyparams) {
    let params = {};
    if (typeof limit !== 'undefined') {
      params.per_page = limit;
    }
    if (typeof offset !== 'undefined') {
      params.page = offset === 0 ? offset / limit + 1 : offset; // / limit + 1;
    }
    if (typeof search !== 'undefined') {
      params.search = search;
    }
    if (typeof sorts !== 'undefined') {
      params.sorts = search;
    }
    if (typeof anyparams !== 'undefined') {
      for (let key in anyparams) {
        params[key] = anyparams[key];
      }
    }
    const { data } = await this.http.get(this.endpoint, params);
    const items = data.items ? data.items.map(item => {
      const id = typeof item.uuid === 'undefined' ? item.id : item.uuid;
      if (this.hasDeserialize()) {
        return { ...item, ...this.deserialize(item), id };
      }
      return { ...item, id };
    }) : data;
    const total = data.total;
    return { items, total, pages: data.pages };
  }

  async get(uuid) {
    const response = await this.http.get(this.endpoint + uuid);
    const data = this.hasDeserialize()
      ? { ...response.data, ...this.deserialize(response.data) }
      : response.data;
    return data;
  }

  async create(data, anyparams) {
    let params = {};
    const body = this.hasSerialize()
      ? { ...data, ...this.serialize(data) }
      : data;
    if (typeof anyparams !== 'undefined') {
      for (let key in anyparams) {
        params[key] = anyparams[key];
      }
    }
    const response = await this.http.post(this.endpoint, body, params);
    return response.data;
  }

  async update(uuid, data) {
    const body = this.hasSerialize()
      ? { ...data, ...this.serialize(data) }
      : data;
    const response = await this.http.put(this.endpoint + uuid, body);
    return response.data;
  }

  async remove(uuid, anyparams) {
    let params = {};
    if (typeof anyparams !== 'undefined') {
      for (let key in anyparams) {
        params[key] = anyparams[key];
      }
    }
    const id = uuid ? uuid : '';
    const response = await this.http.delete(this.endpoint + id, params);
    return response.data;
  }

  hasSerialize() {
    return !(typeof this.serialize === 'undefined');
  }

  hasDeserialize() {
    return !(typeof this.deserialize === 'undefined');
  }
}
